import { SET_GLOBAL_ERRORS/*, SET_SPLASH*/ } from '../constants/ActionTypes';
/*
import axios from 'axios';
import uid from "../utils/generateUid";
import setNotifications from "./setNotifications";
*/

export default function setGlobalErrors(arr,container=null) {
  return {
    type: SET_GLOBAL_ERRORS,
    container: container,
    payload: arr,
  }
  /*
  return (dispatch, getState)=>{
    for(let i in arr) {
      if(arr[i].code==='access_deny') {
        dispatch({
          type: SET_SPLASH,
          payload: 'access_deny',
        });
      }
    }
    dispatch({
      type: SET_GLOBAL_ERRORS,
      container:container,
      payload: arr,
    });
  };
  */
}
